import { Card, CardBody, Container, Row } from "reactstrap";
import { BillingDetails, CheckOutTitle, ECommerce } from "../../../../constants";
import FormContent from "./FormContent";
import Details from "./Details";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

// This component handles the checkout process. It includes the billing details form and the shipping details section.
const CheckOutContainer = () => {

  return (
    <>
      <Breadcrumbs mainTitle={CheckOutTitle} parent={ECommerce} />
      <Container fluid>
        <Card className="checkout custom-billing-details">
          <CommonCardHeader title={BillingDetails} headClass="pb-0"/>
          <CardBody>
            <Row>
              <FormContent />
              <Details />
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default CheckOutContainer;